var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"singularity-top-nav-mobile",class:{ 'is-active': _vm.isPreviewMode }},[_c('IconButton',{attrs:{"size":16,"icon":"PlaySolidIcon","active":_vm.isPreviewMode},on:{"click":_vm.togglePreviewMode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }